"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var _blogger = _interopRequireDefault(require("../blogger"));
var mapInspirationsLanding = function mapInspirationsLanding(response) {
  var _response$page_title$, _response$seodescript, _response$seotitle$;
  if (!response) return;
  var content = [];
  response.body.map(function (element) {
    if (element.slice_type === "banner") {
      var _element$primary$labe, _element$primary$url, _element$primary$url$, _element$primary$blur, _element$primary$titl, _element$primary$subt;
      content.push({
        type: "banner",
        label: element.primary.label ? (_element$primary$labe = element.primary.label[0]) === null || _element$primary$labe === void 0 ? void 0 : _element$primary$labe.text : false,
        link: (_element$primary$url = element.primary.url) === null || _element$primary$url === void 0 ? void 0 : (_element$primary$url$ = _element$primary$url.url) === null || _element$primary$url$ === void 0 ? void 0 : _element$primary$url$.replace("https://", ""),
        leftImage: (0, _image["default"])(element.primary.image, ((_element$primary$blur = element.primary.blurhash) === null || _element$primary$blur === void 0 ? void 0 : _element$primary$blur.length) > 0 && element.primary.blurhash[0].text),
        title: (_element$primary$titl = element.primary.title[0]) === null || _element$primary$titl === void 0 ? void 0 : _element$primary$titl.text,
        subtitle: (_element$primary$subt = element.primary.subtitle[0]) === null || _element$primary$subt === void 0 ? void 0 : _element$primary$subt.text,
        blogger: element.bloggerData ? (0, _blogger["default"])(element.bloggerData) : null,
        backgroundColor: element.primary.background_color,
        textColor: element.primary.text_color
      });
    }
    if (element.slice_type === "boxes") {
      var _element$primary$grou, _element$primary$grou2;
      var boxes = [];
      element.items.map(function (box) {
        var _box$title$, _box$blurhash, _box$url, _box$url$url, _box$subtitle$;
        boxes.push({
          label: (_box$title$ = box.title[0]) === null || _box$title$ === void 0 ? void 0 : _box$title$.text,
          image: (0, _image["default"])(box.image, ((_box$blurhash = box.blurhash) === null || _box$blurhash === void 0 ? void 0 : _box$blurhash.length) > 0 && box.blurhash[0].text),
          link: (_box$url = box.url) === null || _box$url === void 0 ? void 0 : (_box$url$url = _box$url.url) === null || _box$url$url === void 0 ? void 0 : _box$url$url.replace("https://", ""),
          description: (_box$subtitle$ = box.subtitle[0]) === null || _box$subtitle$ === void 0 ? void 0 : _box$subtitle$.text
        });
      });
      content.push({
        type: "boxes",
        label: element.primary.group_title[0].text,
        url: (_element$primary$grou = element.primary.group_url) === null || _element$primary$grou === void 0 ? void 0 : (_element$primary$grou2 = _element$primary$grou.url) === null || _element$primary$grou2 === void 0 ? void 0 : _element$primary$grou2.replace("https://", ""),
        boxes: boxes
      });
    }
  });
  return {
    title: response.page_title && ((_response$page_title$ = response.page_title[0]) === null || _response$page_title$ === void 0 ? void 0 : _response$page_title$.text),
    seoDescription: (_response$seodescript = response.seodescription[0]) === null || _response$seodescript === void 0 ? void 0 : _response$seodescript.text,
    seoTitle: (_response$seotitle$ = response.seotitle[0]) === null || _response$seotitle$ === void 0 ? void 0 : _response$seotitle$.text,
    content: content
  };
};
var _default = mapInspirationsLanding;
exports["default"] = _default;